import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-compras',
  templateUrl: './main-compras.component.html',
  styleUrls: ['./main-compras.component.css']
})
export class MainComprasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
